<template>
  <div class="seg-info-base">
    <div class="_base-col base-logo">
      <div :class="['airline-logo', 'logo',  !setAirlineImage(seg.airlineCode) && `logo-${seg.airlineCode.toLocaleLowerCase()}`]">
        <img v-if="setAirlineImage(seg.airlineCode)" :src="setAirlineImage(seg.airlineCode)" />
      </div>
    </div>
    <div class="_base-col base-dep">
      <p class="base-strong base-time">
        {{ moment(seg.departureTime).format('HH:mm') }}
      </p>
      <p class="base-bord base-city">
        <!-- {{ seg.departureAirPortName }} -->
        {{ seg | departureCity }}
      </p>
    </div>
    <div class="_base-col base-flight">
      <p class="flightNo">{{ seg.flightNo }}</p>
      <div class="hr-line"></div>
      <p class="airplane" v-if="seg.stopCityName">经停：{{ seg | stopCity }}</p>
    </div>
    <div class="_base-col base-arr">
      <p class="base-strong base-time">
        {{ moment(seg.arrivalTime).format('HH:mm') }}
        <small class="time-sup" v-if="moment(seg.arrivalDate).isAfter(seg.departureDate)" >+1</small>
      </p>
      <p class="base-bord base-city">
        <!-- {{ seg.arrivalAirPortName }} -->
        {{ seg | arrivalCity }}
      </p>
    </div>
    <div class="_base-col base-date">
      <p class="_base-top">航班日期</p>
      <p>{{ seg.departureDate }}</p>
    </div>
    <div class="_base-col base-unit">
      <p class="_base-top">舱位</p>
      <p>{{ seg.cabinCode }}/{{ seg.discount | discount }}</p>
    </div>
    <div class="_base-col base-unit base-flightno">
      <p class="_base-top">票号</p>
      <p> <span class="v-m">{{ seg.ticketNo ? seg.issCode + '-' + seg.ticketNo : '--' }}</span>
      </p>
    </div>
    <div class="_base-col base-unit base-remark">
      <p class="_base-top">退改签</p>
      <p>
        <span v-if="seg.refundChangeFee">
          <a-popover
            trigger="click"
            overlayClassName="l8-order-popover order-remark-popover"
            placement="bottom"
          >
            <template slot="content">
              <div class="remark-popover-content">
                <RemarkTable
                  :rule="seg.refundChangeFee"
                  v-if="!ifInternational?.()"
                ></RemarkTable>
                <template v-else>
                  <div class="refund-changes-detail-int" v-html="getRefundChangeFeesInt(seg)"></div>
                </template>
                <!-- <div v-if="!ifInternational?.()" class="remark-notice" v-show="seg.refundChangeFee.change" >
                  <l8-icon class="l8-icon" type="icon-jinggaoicon"/> 以上退改签费用标准仅供参考，请以实际情况为准。<br/>
                  <l8-icon class="l8-icon" type="icon-jinggaoicon"/> 客票变更时，需同时收取票价价差和变更手续费。
                </div>
                <div v-else>
                  <span class="primary-color">1.如您购买往返客票，退改费将按照去回程中更严格一方的标准收取，具体请以实际审核退改金额为准。</span><br/>
                  2.因汇率等时有变动，以上手续费仅供参考，具体可退税费需人工核实，以实际审核退改金额为准。<br>
                  <span class="primary-color">另: 儿童变更/退票手续费按照成人相应规定执行。 不占座婴儿变更/退票免收手续费。</span><br/>
                </div>
                <div class="remark-warn" v-if="seg.refundChangeFee.change && cmsData.refundChangeRuleTips" v-html="cmsData.refundChangeRuleTips"></div> -->
                <refund-rules-detail :ifInternational="ifInternational?.()"></refund-rules-detail>
              </div>
            </template>
            <template slot="title">
              <span>退改签规则</span>
            </template>
            <span class="seg-remark">
              <span class="seg-href v-m" v-if="!ifInternational?.()">{{ seg.refundChangeFee.refundChangeAmount }}元起</span>
              <span class="seg-href v-m" v-else >退改签规则</span>
              <l8-icon class="l8-icon v-m" type="icon-sanx-up"/>
            </span>
          </a-popover>
        </span>
      </p>
    </div>
    <div class="_base-col base-unit base-benefit">
      <p class="_base-top">服务权益</p>
      <div style="padding-left: 15px; ">
        <a-popover
          trigger="hover"
          overlayClassName="l8-order-popover order-primary-popover"
          placement="bottom">
          <template slot="content">
            <div class="popover-benefit-table">
              <benefit-luggage :list="languageBenefitDetails"></benefit-luggage>
              <table>
                <tr v-for="(benefit, bnfIndex) in benefits" :key="bnfIndex">
                  <td>
                    <l8-icon
                      class="benefit-icon l8-icon v-m"
                      :title="benefit.name"
                      :type="benefit.icon || 'icon-zuanshi'"/>
                  </td>
                  <td>
                    <span v-html="benefit.text || benefit.name"></span>
                  </td>
                </tr>
              </table>
            </div>
          </template>
          <template slot="title">
            <span>服务权益</span>
          </template>
          <span v-if="benefits.length !== 0 || languageBenefitDetails.length !== 0">
            <l8-icon class="benefit-icon l8-icon v-m" title="服务权益" type="icon-zuanshi"/>
          </span>
          <span v-else>无</span>
        </a-popover>
      </div>
    </div>
    <div class="_base-col base-unit base-status">
      <p class="_base-top">客票状态</p>
      <p>{{ seg.ticketStatusCn || '--' }}</p>
    </div>
    <div class="_base-col base-price" v-if="!ifInternational?.()">
      <p class="_base-top">总票价</p>
      <p class="info-price">
        <tax-popover :segment="seg" :ifInternational="ifInternational?.()"></tax-popover>
      </p>
    </div>
  </div>
</template>

<script>
import '@/components/l8-icon'
import _ from 'lodash'
import RemarkTable from './remark-table.vue'
import benefitLuggage from '@/components/benefits/luggage'
import refundRulesDetail from '@/components/benefits/refund-rules-detail'
import taxPopover from './tax-popover.vue'
import getAppInfo from '@/utils/from'
import { setAirlineImage } from '@/assets/js/util'

export default {
  name: 'SegmentInfo',
  props: {
    order: {
      type: Object,
      default: function () {
        return {}
      }
    },
    seg: {
      type: Object
    },
    cmsData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  inject: {
    ifInternational: {
      value: 'ifInternational',
      default: null
    }
  },
  watch: {
    seg: function () {
      this.updateBenefit()
    }
  },
  data () {
    return {
      remark: {},
      remarkLoading: true,
      benefits: [],
      showRemark: true,
      languageBenefitDetails: [],
      appInfo: getAppInfo()
    }
  },
  created () {
    if (!this.$attrs['always-remark']) { // 如果false，根据bookeDate是否有值控制显示
      this.showRemark = !!this.seg.bookDate
    }

    this.updateBenefit()
  },
  methods: {
    setAirlineImage,
    updateBenefit () {
      let beneMap = {
        'FREE_LUGGUE': {
          icon: 'icon-gongjuxiang',
          _text: '免费托运行李'
        },
        'UPMARKET_CHECK_IN_DESK': {
          icon: 'icon-jiedai',
          _text: '专属值机柜台'
        },
        'JP_REWARD_POINTS': {
          icon: 'icon-jifen2',
          _text: '累积积分'
        },
        'FOOD_IN_THE_AIR': {
          icon: 'icon-can',
          _text: '免费餐食'
        },
        'MEAL': {
          icon: 'icon-can',
          _text: '免费餐食'
        },
        'JJC_SEAT': {
          icon: 'icon-smile',
          _text: '经济舱座位'
        },
        'VIP_ROOM': {
          icon: 'icon-shafa',
          _text: '机场贵宾厅'
        },
        'BUSSINES_CHECK_IN_DESK': {
          icon: 'icon-jiedai',
          _text: '专属值机柜台'
        },
        'PRIORITY_SECURITY_CHECK_CHANNEL': {
          icon: 'icon-anjianchu1',
          _text: '优先安检通道'
        },
        'HIGHT_PIORITY_CHECK_IN': {
          icon: 'icon-feiji1',
          _text: '登机口优先登机'
        },
        'PERSONAL_CAR_TRAN': {
          icon: 'icon-qiche',
          _text: '远机位专车接驳'
        },
        'CABIN_SERVICE': {
          icon: 'icon-smile',
          _text: '品质客舱服务'
        },
        'EXTRA_REWARD_POINTS': {
          icon: 'icon-jifen2',
          _text: '额外积分'
        },
        'CHEAP_REFUND_CHANGE_SIGEN': {
          icon: 'icon-xunhuan',
          _text: '优惠退改签'
        },
        'ADVANCE_FREE_CHANGE': {
          icon: 'icon-xunhuan',
          _text: '免费改期'
        },
        'CARRY_LUGGUE': {
          icon: 'icon-gongjuxiang',
          _text: '手提行李'
        },
        'HIGH_JP_REWARD_POINTS': {
          icon: 'icon-jifen2',
          _text: '高额金鹏积分'
        },
        'DISCOUNT_ONBOARD_UP_CABIN': {
          icon: 'icon-xunhuan',
          _text: '优惠机上升舱'
        },
        'HOUR72_FREE_CHANGE': {
          icon: 'icon-xunhuan',
          _text: '72H外免费改期一次'
        }
      }

      if (this.seg.benefits) {
        const benefits = this.seg.benefits
        this.languageBenefitDetails = []
        benefits.languageBenefitDetails.forEach(element => {
          if (element.checkinBenefit) {
            element.checkinBenefit.passengerType = element.passengerType
            this.languageBenefitDetails.push(element.checkinBenefit)
          }
          if (element.carryBenefit) {
            element.carryBenefit.passengerType = element.passengerType
            this.languageBenefitDetails.push(element.carryBenefit)
          }
        })
      }

      if (this.seg.benefits) {
        this.benefits = _.map(JSON.parse(JSON.stringify(this.seg.benefits.benefitDetails)), (benefit) => {
          return _.assign(benefit, beneMap[benefit.code])
        })
      }
    },
    getRefundChangeFeesInt (seg) {
      return seg.intTicketRuleText?.replaceAll('\n', '<br>')
    }
  },
  components: {
    RemarkTable,
    benefitLuggage,
    refundRulesDetail,
    taxPopover
  },
  filters: {
    discount (val) {
      const value = parseFloat(val)

      if (isNaN(value)) {
        return '-'
      }

      return value >= 1 ? '全价' : `${(value * 10).toFixed(1)}折`
    },
    stopCity (value) {
      const terminal = value.stopTerminal || ''
      return value.stopAirportName ? value.stopAirportName + terminal : '-'
    },
    arrivalCity (value) {
      const terminal = value.arrivalTerminal || ''
      return value.arrivalAirPortName ? value.arrivalAirPortName + terminal : '-'
    },
    departureCity (value) {
      const terminal = value.departureTerminal || ''
      return value.departureAirPortName ? value.departureAirPortName + terminal : '-'
    }
  }
}
</script>

<style lang="less">
.popover-benefit-table {
  padding: 20px;
  tr {
    td {
      &:first-child {
        padding: 0 10px;
      }
    }
  }
}
.benefit-icon {
  color: #9c8c6c;

  &.l8-icon {
    font-size: 14px;
  }
}

.refund-changes-detail-int{
  line-height: 1.8;
}

.cell-body {
    padding: 10px 18px;
    font-size: 12px;
    color: #808080;

    > div {
      margin: 10px 0;

      .anticon {
        font-size: 16px;
      }
    }

    th,
    td {
      padding: 8px;
      border: 1px solid #b7b7b7;
      text-align: center;

      &:first-child {
        background-color: #f5f5f5;
      }
    }

    .bussiness-tip {
      h6 {
        margin: 6px 0;
        color: @primary-color;
        font-size: 16px;
      }
    }
  }

</style>
